import React from "react"
import { useState } from 'react'
import TodoItem from "./TodoItem"

const styles = {
    btn: {
        background: 'grey',
        margin: '5px',
        padding: '5px',
        borderRadius: '10px',
        color: 'white'
    },
    btnRed: {
        background: "#f50057",
        margin: '5px',
        padding: '5px',
        borderRadius: '10px',
        color: 'white'
    },
    img: {
        width: '90px',
        height: '90px',
        borderRadius: '50%',
      }
}

export default function Gallery({todos}) {

    const [ind, setIndex] = useState(0)
    const [showDetails, setShowDetails] = useState(true);

    function nextImg() {
        setIndex(ind === todos.length - 1 ? 0 :ind + 1)
    }

    function showHideDetails() {
        setShowDetails(!showDetails);
      }

    return(
    <div>
        <h3>Voir les caractéristiques du super-Héros</h3>
        <TodoItem todo={todos[ind]}/>
        
        <button 
            style={styles.btnRed} 
            onClick={() => nextImg(ind)}
        >
            Next
        </button>

        <button onClick={showHideDetails}
            style={styles.btn} >
            {showDetails ? '(-) Hide' : '(+) Show'} details
        </button>
        <div>
            {showDetails && <p>{todos[ind].title}: {todos[ind].description}</p>}
        </div>
    </div>
)}